/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LegacyFormRouteImport } from './routes/legacy-form'
import { Route as DesignRouteImport } from './routes/design'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'

const LegacyFormRoute = LegacyFormRouteImport.update({
  id: '/legacy-form',
  path: '/legacy-form',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/design': typeof DesignRoute
  '/legacy-form': typeof LegacyFormRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/design': typeof DesignRoute
  '/legacy-form': typeof LegacyFormRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/design': typeof DesignRoute
  '/legacy-form': typeof LegacyFormRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$' | '/design' | '/legacy-form'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$' | '/design' | '/legacy-form'
  id: '__root__' | '/' | '/$' | '/design' | '/legacy-form'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  DesignRoute: typeof DesignRoute
  LegacyFormRoute: typeof LegacyFormRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/legacy-form': {
      id: '/legacy-form'
      path: '/legacy-form'
      fullPath: '/legacy-form'
      preLoaderRoute: typeof LegacyFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  DesignRoute: DesignRoute,
  LegacyFormRoute: LegacyFormRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
